export const COLORS = [
  {value: '#000000', label: 'Black'},
  {value: '#ffffff', label: 'White'},
  {value: '#ef4444', label: 'Red'},
  {value: '#fca5a5', label: 'Light Red'},
  {value: '#10b981', label: 'Green'},
  {value: '#6ee7b7', label: 'Light Green'},
  {value: '#3b82f6', label: 'Blue'},
  {value: '#93c5fd', label: 'Light Blue'},
  {value: '#facc15', label: 'Yellow'},
  {value: '#fde047', label: 'Light Yellow'},
  {value: '#ec4899', label: 'Pink'},
  {value: '#f9a8d4', label: 'Light Pink'},
  {value: '#8b5cf6', label: 'Purple'},
  {value: '#c4b5fd', label: 'Light Purple'},
  {value: '#06b6d4', label: 'Cyan'},
  {value: '#67e8f9', label: 'Light Cyan'},
  {value: '#d6b28e', label: 'Brown'},
  {value: '#e7cba0', label: 'Light Brown'},
  {value: '#6b7280', label: 'Gray'},
  {value: '#d1d5db', label: 'Light Gray'},
];

export interface QuillModulesConfig {
  toolbar: {
    container: string;
    handlers: Record<string, () => void>;
  };
  history: {
    delay: number;
    maxStack: number;
    userOnly: boolean;
  };
}
